/**
 * Mobile & Internet Coverage Module
 * Handles the Ofcom mobile network coverage selector on UK detail pages.
 * When a network is selected from the dropdown, shows that carrier's
 * coverage card and hides any previously shown card.
 */

export function initMobileCoverage() {
    const select = document.getElementById('mobile-network');
    if (!select) return;

    const carriers = document.querySelectorAll('.coverage-carrier');
    if (!carriers.length) return;

    select.addEventListener('change', () => {
        const selected = select.value;

        carriers.forEach(card => {
            if (card.dataset.carrier === selected) {
                card.classList.add('coverage-carrier--active');
            } else {
                card.classList.remove('coverage-carrier--active');
            }
        });
    });
}
